import script from "./DeleteProductModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteProductModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteProductModal.vue?vue&type=style&index=0&id=0a662c55&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a662c55"]])

export default __exports__